
$(document).ready(function() {  

  bundle_product();
  topBarSlider();
  mainSlideshow();
  featuredCollectionSlider();
  iconWithText();
  iconWithTextSlider();
  footIcons();
  pdpIngredientSlider();
  blogSlider();
  testimonialSlider();
 
  
  // Show the first tab by default
  $('.tabs-stage .tabs-content-wrapper').hide();
  $('.tabs-stage .tabs-content-wrapper:first').show();
  $('.tabs-nav li:first').addClass('tab-active');
  
  // Change tab class and display content
  $('.tabs-nav a').on('click', function(event){
    event.preventDefault();
    $('.tabs-nav li').removeClass('tab-active');
    $(this).parent().addClass('tab-active');
    $('.tabs-stage .tabs-content-wrapper').hide();
    $($(this).attr('href')).show();
  });


   $('#faq-tabs-nav li:first-child').addClass('active');
    $('.faq_tab-content').hide();
    $('.faq_tab-content:first').show();
    
    $('#faq-tabs-nav li').click(function(){
      $('#faq-tabs-nav li').removeClass('active');
      $(this).addClass('active');
      $('.faq_tab-content').hide();
      
      var activeTab = $(this).find('a').attr('href');
      $(activeTab).fadeIn();
      return false;
    });

    $(".faq__title").click(function () {
      $(this).toggleClass("active").next(".faq_accordion__content").slideToggle().parent().siblings().find(".faq_accordion__content").slideUp().prev().removeClass("active");
    });

});


function bundle_product() {  
   if(!document.querySelector('.main-product-wrapper .cstm_product_swiper')) return;
   var parentSwiper = new Swiper('.cstm_product_swiper', {
      slidesPerView: 3,
      slidesPerGroup: 1,
      spaceBetween: 20,
      loop: false,
      autoHeight: true,
      pagination:{
         el: '.swiper-pagination',
         clickable:true
       },
      breakpoints:{
        0: {
          navigation: false,
          slidesPerView:1.3
        },
        375: {
          navigation: false,
          slidesPerView:2.3
        },
        750: {
          navigation: false,
          slidesPerView:1.7
          // pagination: true
         },
        1199: {
          navigation: false,
          slidesPerView:2.7
          // pagination: true
         }
       }
    });
  
}
function mainSlideshow() { 
  // Check if the swiper element exists
  if (!document.querySelector('.slideshow-video-main-wrapper .swiper')) return;

  // Parse the slider options from the data attribute
  var sliderOption = JSON.parse(document.querySelector('.slideshow-video-main-wrapper .swiper').dataset.sliderOptions);

  // Initialize the Swiper with the correct options
  var swiper = new Swiper(".slideshow-video-main-wrapper .swiper", sliderOption);  // Pass the options directly here
}
 
function topBarSlider() { 
  if(!document.querySelector('.top-bar-wrapper .topBarSlider')) return;
  
  var swiper = new Swiper(".topBarSlider", {    
      slidesPerView: 'auto',
      spaceBetween: 120, 
      breakpoints: {  
        10: {
          slidesPerView: 1,
          spaceBetween: 20,        
        },
        450: {
          slidesPerView: 1,
          spaceBetween: 20,
        },
        750: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        991: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        1199: {
          slidesPerView: 'auto',
          spaceBetween: 80,
        },
      },
  });    
}

function iconWithText() { 
  if(!document.querySelector('.icon-with-text-wrapper .iconTextSlider')) return;
  
  var swiper = new Swiper(".iconTextSlider", {    
    slidesPerView: 4,
    spaceBetween: 20,
      breakpoints: {  
        10: {
          slidesPerView: 1.4,
          spaceBetween: 20,
          initialSlide: 1,
          pagination: {
            el: ".swiper-pagination",
            clickable: true,
          },
        },
        450: {
          slidesPerView: 1.4,
          spaceBetween: 20,
          pagination: {
            el: ".swiper-pagination",
            clickable: true,
          },
        },
        750: {
          slidesPerView: 3,
          spaceBetween: 20,
          pagination: {
            el: ".swiper-pagination",
            clickable: true,
          },
        },
        991: {
          slidesPerView: 3,
          spaceBetween: 20,
          pagination: {
            el: ".swiper-pagination",
            clickable: true,
          },
        },
        1199: {
          slidesPerView: 4,
          spaceBetween: 30,
        },
      },
  });    
}

function iconWithTextSlider() { 
  if(!document.querySelector('.icon-with-text-section .iconWithTextSlider')) return;

  var swiper = new Swiper(".iconWithTextSlider", {    
    slidesPerView: 'auto',
    spaceBetween: 80, 
    breakpoints: {
      10: {
        slidesPerView: 2,
        spaceBetween: 0,
      },
      450: {
        slidesPerView: 2,
        spaceBetween: 0,
      },
      750: {
        slidesPerView: 'auto', 
        spaceBetween: 80, 
      },
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
  });    
}

function footIcons() { 
  if(!document.querySelector('.shipping-information-wrapper .footIcons')) return;
  
  var swiper = new Swiper(".footIcons", {    
    slidesPerView: 'auto',
    spaceBetween: 100,     
    // navigation: {
    //   nextEl: ".footButton-next",
    //   prevEl: ".footButton-prev",
    // },
    breakpoints: {  
        10: {
          slidesPerView: 1,
          spaceBetween: 0,
          initialSlide: 1,          
        },
        450: {
          slidesPerView: 1,
          spaceBetween: 0,          
        },
        768: {
          slidesPerView: 2,
          spaceBetween: 20,          
        },
        1199: {
          slidesPerView: 'auto',
          spaceBetween: 100,          
        }
      },
  });    
}

function pdpIngredientSlider() { 
  if(!document.querySelector('.product-ingredient-wrapper .pdpIngredientSlider')) return;
  
  var swiper = new Swiper(".pdpIngredientSlider", {    
    slidesPerView: 'auto',
    spaceBetween: 35,     
    breakpoints: {  
        10: {
          slidesPerView: 1.2,
          spaceBetween: 20,
          initialSlide: 1,          
        },
        450: {
          slidesPerView: 1.5,
          spaceBetween: 20,          
        },
        768: {
          slidesPerView: 2,
          spaceBetween: 20,          
        },
        1220: {
          slidesPerView: 'auto',
          spaceBetween: 35,          
        }
      },
      pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
  });    
}

function blogSlider() { 
  if(!document.querySelector('.section-featured-blog-wrapper .blogSlider')) return;
  
  var swiper = new Swiper(".blogSlider", {    
      slidesPerView: 3,
      spaceBetween: 20,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      breakpoints: {  
        10: {
          slidesPerView: 1,
          spaceBetween: 20,        
        },
        450: {
          slidesPerView: 1,
          spaceBetween: 20,
        },
        750: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        991: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        1199: {
          slidesPerView: 3,
          spaceBetween: 20,
        },
      },
  });    
}



function featuredCollectionSlider() {
  // Select all featured collection wrappers
  document.querySelectorAll('.featured-collection-wrapper .featured-collection-slider').forEach((sliderEl) => {
    
    // Get slider settings from dataset attributes
    let desktopSliderPerView = Number(sliderEl.dataset.sliderItems) || 'auto';
    let SliderPerViewAuto = sliderEl.dataset.sliderAuto;
    let secId = sliderEl.closest('.featured-collection-wrapper .collection').dataset.id;
    let secIdElement = document.querySelector(`.featured-collection-wrapper .collection[data-id="${secId}"]`);
    
    // Initialize Swiper for each slider
    new Swiper(sliderEl, {
      pagination: {
        el: secIdElement.querySelector(".featured-swiper-pagination"),
        clickable: true,
      },
      breakpoints: {
        10: {
          slidesPerView: 2,
          spaceBetween: 20,
          initialSlide: 1,
        },
        450: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        750: {
          slidesPerView: SliderPerViewAuto === 'true' ? 'auto' : 3,
          spaceBetween: 20,
        },
        991: {
          slidesPerView: SliderPerViewAuto === 'true' ? 'auto' : 3,
          spaceBetween: 30,
        },
        1199: {
          slidesPerView: SliderPerViewAuto === 'true' ? 'auto' : desktopSliderPerView,
          spaceBetween: 30,
        },
      },
    });
  });
}



// function featuredCollectionSlider() { 
//   if(!document.querySelector('.featured-collection-wrapper .featured-collection-slider')) return;
  
//   let desktopSliderPerView = Number(document.querySelector('.featured-collection-slider').dataset.sliderItems )|| 'auto';
//   let SliderPerViewAuto = document.querySelector('.featured-collection-slider').dataset.sliderAuto;  
//   let secId = document.querySelector('.featured-collection-wrapper .collection').dataset.id;  
//   let secIdEliment = document.querySelector(`.featured-collection-wrapper .collection[data-id="${secId}"]`)
     
//   var swiper = new Swiper(".featured-collection-slider", {    
//       pagination: {
//         el: secIdEliment.querySelector(".featured-swiper-pagination"),
//         clickable: true,
//       },
//       breakpoints: {  
//         10: {
//           slidesPerView:  SliderPerViewAuto == 'true'?'auto': 2,
//           spaceBetween: 20,
//           initialSlide: 1,
//         },
//         450: {
//           slidesPerView:  SliderPerViewAuto == 'true'?'auto': 2,
//           spaceBetween: 20,
//         },
//         750: {
//           slidesPerView:  SliderPerViewAuto == 'true'?'auto': 3,
//           spaceBetween: 20,
//         },
//         991: {
//           slidesPerView:  SliderPerViewAuto == 'true'?'auto': 3,
//           spaceBetween: 30,
//         },
//         1199: {
//           slidesPerView:  SliderPerViewAuto == 'true'?'auto': desktopSliderPerView,
//           spaceBetween: 30,
//         },
//       },
//   });    
// }


function testimonialSlider() { 
  if(!document.querySelector('.testimonials-box-wrapper .testimonialSlider')) return;
  
  var swiper = new Swiper(".testimonialSlider", {    
    slidesPerView: 1,
    autoHeight: true,
    spaceBetween: 0,     
    navigation: {
      nextEl: ".testiButton-next",
      prevEl: ".testiButton-prev",
    },
    pagination: {
        el: ".swiper-pagination",
        clickable: true,
    },
    // breakpoints: {  
    //     10: {
    //       slidesPerView: 1,
    //       spaceBetween: 0,
    //       initialSlide: 1,          
    //     },
    //     450: {
    //       slidesPerView: 1,
    //       spaceBetween: 0,          
    //     },
    //     750: {
    //       slidesPerView: 3,
    //       spaceBetween: 20,          
    //     },
    //   },
  });    
}


if (Shopify.designMode) {
   document.addEventListener("DOMContentLoaded", function() {
    document.addEventListener('shopify:section:load', function(){
      
     const mainSlideshowSection = event.target.closest('.slideshow-video-main-wrapper') || null;
      if(mainSlideshowSection){
        mainSlideshow();
      }
  
      const topBarSliderSection = event.target.closest('.top-bar-wrapper') || null;
      if(topBarSliderSection){
        topBarSlider();
      }
      
      const featuredCollectionSliderSection = event.target.closest('.featured-collection-wrapper') || null;
      if(featuredCollectionSliderSection){
        featuredCollectionSlider();
      }
      
      const iconWithTextSection = event.target.closest('.icon-with-text-wrapper') || null;
      if(iconWithTextSection){
        iconWithText();
      }
      
      const iconTextSliderSection = event.target.closest('.icon-with-text-section') || null;
      if(iconTextSliderSection){
        iconWithTextSlider();
      }
      
      const footIconsSection = event.target.closest('.shipping-information-wrapper') || null;
      if(footIconsSection){
        footIcons();
      }
      
      const pdpIngredientSliderSection = event.target.closest('.product-ingredient-wrapper') || null;
      if(pdpIngredientSliderSection){
        pdpIngredientSlider();
      }

      const blogSliderSection = event.target.closest('.section-featured-blog-wrapper') || null;
      if(blogSliderSection){
        blogSlider();
      }

      const testimonialSliderWrapper = event.target.closest('.testimonials-box-wrapper') || null;
      if(testimonialSliderWrapper){
        testimonialSlider();
      }
      
    });
  });
}

// PASSWORD SHOW AND HIDE start

// class ShowPassword extends HTMLElement {
//   constructor() {
//     super();
//     const facetLink = this.querySelector('a');
//     facetLink.setAttribute('role', 'button');
//     facetLink.addEventListener('click', this.show_password.bind(this));
//   }

//   show_password(event) {
//     event.preventDefault();
//     this.closest('.form-field').querySelector('input').setAttribute('type', this.closest('.form-field ').querySelector('input').getAttribute('type') === 'password' ? 'text' : 'password');
//     this.classList.toggle('show-password');
//   }
// }

// customElements.define('show-password', ShowPassword);
// PASSWORD SHOW AND HIDE END

class ShowPassword extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.show_password.bind(this));
  }

  show_password(event) {
    event.preventDefault();
    
    // Select the input field relative to the 'show-password' element
    const inputField = this.closest('.field').querySelector('input');
    
    // Toggle the input type between 'password' and 'text'
    inputField.setAttribute('type', inputField.getAttribute('type') === 'password' ? 'text' : 'password');
    
    // Optionally toggle a class to change the icon or style
    this.classList.toggle('show-password');
  }
}

// Define the custom element
customElements.define('show-password', ShowPassword);

function custom_addtocart_fun(product,open_drawer){
      fetch(`${routes.cart_add_url}`,{ 
              method: 'POST',
              headers: { "Accept": "application/json", "Content-Type": "application/json" },
              body: JSON.stringify(product)
        })
        .then(response => response.json()).then(response => {     
          // console.log(response);   
        })
        .catch((error) => {
          console.error('Error:', error);
        })
        .finally((e) => {
          // console.log("finally");
          if(open_drawer){
            const this_cartDrawer = document.querySelector('cart-drawer');
            this_cartDrawer.refresh(true);
          }
        });
}

  document.addEventListener('DOMContentLoaded', function() {
  const accordions = document.querySelectorAll('.accordion details');

  accordions.forEach((accordion) => {
    accordion.addEventListener('toggle', function() {
      if (this.open) {
        accordions.forEach((item) => {
          if (item !== this) {
            item.removeAttribute('open');
          }
        });
      }
    });
  });
});

//mobile faq dropdown toggle
const dropdown = document.querySelector(".active-dropdown-tab");
if(dropdown){
  dropdown.addEventListener("click",function (title) {
    const content = document.querySelector(".faqdrop");  
    if (content.style.display === 'none') {
      content.style.display = 'block'; 
    } else {
      content.style.display = 'none'; 
    }
  });
}

//mobile dropdown content show
const titles = document.querySelectorAll(".faq-title"); 
if(titles){
   titles.forEach((title) => {
   title.addEventListener("click",function (event) {
    
    const target = event.target.closest('a');
     
    const dropdown = document.querySelector(".faqdrop");  
    dropdown.style.display = 'none'; 
     const click_attr = title.getAttribute("data-faq-title");
        document.querySelectorAll(".tabs-content-wrapper-mobile").forEach((content) => {
         const title_attr = content.getAttribute("data-title");
         if(click_attr == title_attr)
         {
           content.style.display = "block";           
         }
         else{
            content.style.display = "none";
         }
      });
     if(target){
       document.querySelector(".active-dropdown-tab").textContent = target.textContent;    
     }     
   });
 });
}
